<template>
  <div class="faq-page">
    <!-- FAQ Background Section -->
    <section class="whaybest faq-bg">
      <div class="fadeIn">
        <img class="faq-img" src="/static/images/faq-min.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/hengfu%402x.png" alt="FAQ Background" ref="lazyImg" />
        <div class="faq-line"></div>
        <div class="faq-title">ASKED<br> QUESTIONS</div>
      </div>
    </section>

    <!-- FAQ Content Section -->
    <section id="faq" class="faq">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="panel-group accordion">
              <div class="panel" v-for="(faq, index) in faqs" :key="index">
                <div class="panel-heading">
                  <h4 
                    class="panel-title" 
                    @click="toggleFAQ(index)"
                    :class="{ active: activeFAQ === index }"
                  >
                    {{ faq.question }}
                  </h4>
                </div>
                <div 
                  class="panel-collapse" 
                  :class="{ show: activeFAQ === index }"
                >
                  <div class="panel-body">
                    <p v-html="faq.answer"></p>
                  </div>
                </div>
                <div class="half-border"></div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </section>
  
  </div>
</template>

<script>
import { lazyLoadingMixin } from '@/mixins/lazyLoading'

export default {
  name: 'FAQ',
  mixins: [lazyLoadingMixin],
  components: {
  },
  data() {
    return {
      activeFAQ: null,
      faqs: [
        {
          question: 'How can I buy a Anovator device?',
          answer: 'Please contact us at info@anovator.com and we will be in touch within a day.'
        },
        {
          question: 'What about the delivery?',
          answer: 'Just depend on your actual request and door to door services by air or by sea is acceptable. Such as DHL, UPS, TNT, FEDEX......by air; and the sea transportations.'
        },
        {
          question: 'How do I initiate after-sales service?',
          answer: '1. Please contact Anovator customer support to initiate after-sales, please explain the reason and provide the invoice or screenshot to confirm the order number.<br />2. Anovaor customer service will reply within 24 working hours.'
        },
        {
          question: 'What is Your Delivery Time?',
          answer: 'Within 7-14 working days after receiving the advance payment (according to the quantity).'
        },
        {
          question: 'How should I clean my device?',
          answer: 'We recommend using alcohol-based wipes to clean our devices. Please avoid using large amounts of water, corrosive liquids, or high pressure washers during cleaning, as this may damage the internal electronics. Always disconnect the device from the mains power supply before cleaning to minimize risk of electric shock.'
        },
        {
          question: 'Can patients outside the recommended age range use BIA devices?',
          answer: 'Anovator Body Composition Analyzers have a specified age range for measurement accuracy. For example, the <br/> recommended age range for best results is between 6 and 85 years old for the MA601 and MA801. This is not <br/> due to safety concerns - BIA is safe for all ages, and you can safely measure someone that is outside of the recommended age range with no problem!'
        },
        {
          question: 'Can BIA be used by users with stents?',
          answer: 'Patients with embedded electronical medical devices (ex: pacemakers) are prohibited from using Bioelectrical Impedance Analysis (BIA) devices, because of the fear of the electrical current used for measurement affecting the embedded device.<br /> <br />Because stents are not powered by electricity, there is no potential safety risk caused by BIA measurement.<br /> <br />In general, there is the potential for slight measurement inaccuracy if the patient has significant amounts of metal embedded in their body, as metal is highly conductive, which may cause the device to misinterpret results. However, stents are not nearly large enough to make a noticeable difference like a large metal implant in your foot might.'
        },
        {
          question: 'How will results be affected by measurement after exercise?',
          answer: 'Exercise can cause a temporary change in impedance, and thus may influence measurement results. Intensive <br/> exercise can increase blood circulation that may continue for an extended period of times, and we recommend <br/> avoiding measurements shortly after exercise.'
        },
        {
          question: 'Who should not use the Body Composition analyzers, and why?',
          answer: 'BIA scans are not recommended for the following groups:<br /> <br /><span style="font-weight: 600;">Pregnancy, Nursing Mothers</span> - Body composition algorithms are based on "normal" healthy adults. Because body composition for pregnant women and nursing mothers is relatively inconsistent (particularly body water), results should be used for reference only.<br /> <br /><span style="font-weight: 600;">Prosthetics, Amputation</span> - Measurement current needs to pass through both hands and feet to operate correctly. If subject has amputated limbs or prosthetics, the scan will not function correctly.<br /> <br /><span style="font-weight: 600;">Embedded Metal</span> - Measurement utilizes electrical conductivity properties of the human body. Metal conductivity is higher than that of body tissue, and may cause inaccurate measurement results.'
        },
        {
          question: 'What should I do to ensure I receive accurate results?',
          answer: 'For best results, we recommend following the guidelines below:<br /><br /><span style="font-weight: 600;">No vigorous exercise</span> - Measure before exercise, not after! Exercise affects circulation and body water, which will affect measurement accuracy.<br /><br /><span style="font-weight: 600;">Use the bathroom</span> - The effect of body waste on electrical conductivity is unknown, and may be interpreted as fat mass.<br /><br /><span style="font-weight: 600;">Avoid food and drink 2 hours before measurement</span> - The effect of food and drink (digested and undigested) on electrical conductivity is unknown, and may be interpreted as fat mass.<br /><br /><span style="font-weight: 600;">Input data correctly</span> - Charder body composition analyzers utilize input data (Height, Age, Gender) and measurement data (Weight, Impedance) to measure body composition. If input is incorrect, interpretation of results will also be inaccurate.'
        }
      ]
    }
  },
  mounted() {
    document.title = 'FAQ - Anovator | smart body composition analyzer';
  },
  methods: {
    toggleFAQ(index) {
      this.activeFAQ = this.activeFAQ === index ? null : index;
    }
  }
}
</script>

<style scoped>
/* Vue特定的样式，不与原始CSS冲突 */
.faq-page {
  min-height: 100vh;
}

.panel-title:hover {
  color: #EF0A6A;
}

.panel-title.active {
  color: #EF0A6A;
}

.panel-title.active::before {
  font-family: "Font Awesome 5 Free";
  content: "-";
}

.panel-collapse {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.panel-collapse.show {
  max-height: 1000px;
}

.panel-body {
  color: #FFFFFF;
  line-height: 1.8;
}

.panel-body p {
  margin: 0;
  font-size: 1rem;
}
.faq-img{
  z-index: 2;
}
</style>